import { clsx } from 'clsx';
import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { SingleSelectItem, ensureChildrenVisibility } from '../../../internal';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectDesktopDropdown(props) {
  var open = props.open,
    value = props.value,
    options = props.options,
    focusedIndex = props.focusedIndex,
    actions = props.actions,
    onKeyDown = props.onKeyDown,
    insideRefs = props.insideRefs;
  var optionsContainerRef = React.useRef(null);
  var focusedOptionRef = React.useRef(null);
  React.useEffect(function () {
    var optionsContainer = optionsContainerRef.current;
    var focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  var bindHandleOptionClickIndex = function bindHandleOptionClickIndex(index) {
    return function () {
      actions.selectOption(index);
      actions.closeDropdown();
    };
  };
  var bindHandleOptionMouseMoveIndex = function bindHandleOptionMouseMoveIndex(index) {
    return function () {
      if (focusedIndex !== index) {
        actions.setFocusedIndex(index);
      }
    };
  };
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsx("div", {
      ref: optionsContainerRef,
      className: styles['list'],
      role: "listbox",
      onKeyDown: onKeyDown,
      children: options.map(function (option, index) {
        var optionValue = option.value;
        var key = String(optionValue);
        var focused = index === focusedIndex;
        var selected = value === optionValue;
        return /*#__PURE__*/_jsx("div", {
          ref: focused ? focusedOptionRef : undefined,
          className: clsx(styles['item-wrapper'], focused && styles['focused']),
          onClick: bindHandleOptionClickIndex(index),
          onMouseMove: bindHandleOptionMouseMoveIndex(index),
          role: "option",
          "aria-selected": selected ? 'true' : undefined,
          tabIndex: 0,
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected
          })
        }, key);
      })
    })
  });
}